import { render, staticRenderFns } from "./DataCnView.vue?vue&type=template&id=dd04ef9c&"
import script from "./DataCnView.vue?vue&type=script&lang=ts&"
export * from "./DataCnView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports